import { Button, Heading, Input, Text } from "components/common";
import { logo } from "images";
import { FaGoogle, FaGithub } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import classes from "./SignUp.module.css";
import clsx from "clsx";
import { useState } from "react";
import DeployService from "../../components/Authentication/DeployService/DeployService";
import AccountCreated from "components/Authentication/SuccessContainer/SuccessContainer";
import { MdErrorOutline } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [accountCreated, setAccountCreated] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false); // Tracks if the form has been submitted
  const [errors, setErrors] = useState({
    emailExists: false,
    userNameUnAvailable: false,
    passwordMismatch: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true); // Set formSubmitted to true on submit

    const newErrors = {
      emailExists: email === "example@gmail.com", // Mock email exists
      userNameUnAvailable: userName === "admin" || userName === "", // Mock username unavailable
      passwordMismatch: password !== confirmPassword,
    };

    setErrors(newErrors);

    // If no errors, set account created
    if (
      !newErrors.emailExists &&
      !newErrors.userNameUnAvailable &&
      !newErrors.passwordMismatch
    ) {
      setAccountCreated(true);
    }
  };
  // content
  const emailExistenceInfo = errors.emailExists && formSubmitted && (
    <Text xs className={classes.errorsContainer}>
      Email already exists.
    </Text>
  );
  const emailExistanceIcon = errors.emailExists && formSubmitted && (
    <MdErrorOutline className={classes.errorIcon} />
  );
  const userNameAvialibilityInfo =
    formSubmitted &&
    (errors.userNameUnAvailable ? (
      <Text xs className={classes.errorsContainer}>
        Username is unavailable.
      </Text>
    ) : (
      <Text xs className={classes.availAbleContainer}>
        Username is available.
      </Text>
    ));
  const userNameAvialibilityIcon =
    formSubmitted &&
    (errors.userNameUnAvailable ? (
      <MdErrorOutline className={classes.errorIcon} />
    ) : (
      <FaCheck className={classes.successIcon} />
    ));
  const passwordMismatchInfo = errors.passwordMismatch && formSubmitted && (
    <Text xs className={classes.errorsContainer}>
      Passwords do not match.
    </Text>
  );

  return (
    <>
      <main className={clsx(classes.mainWrapper, "container")}>
        {!accountCreated && (
          <div className={classes.wrapper}>
            <form className={clsx(classes.container)} onSubmit={handleSubmit}>
              <img src={logo} alt="#" className={classes.logo} />
              <Heading xl font600 textCenter primary>
                Create your account
              </Heading>
              <div className={classes.buttonContainer}>
                <Button primitive700 wFull>
                  <FaGoogle className={classes.icon} />
                  Google
                </Button>{" "}
                <Button primitive700 wFull>
                  <FaGithub className={classes.icon} />
                  Github
                </Button>
              </div>
              <Text xs primitive400 textCenter>
                or
              </Text>
              <div className={classes.inputWrapper}>
                <Input
                  name="email"
                  value={email}
                  setValue={setEmail}
                  type="email"
                  placeholder="Email address"
                  className={clsx(
                    errors.emailExists && formSubmitted && classes.error
                  )}
                  icon={emailExistanceIcon}
                />
                {emailExistenceInfo}
                <Input
                  name="userName"
                  value={userName}
                  setValue={setUserName}
                  placeholder="Username"
                  icon={userNameAvialibilityIcon}
                  className={clsx(
                    formSubmitted &&
                      (errors.userNameUnAvailable
                        ? classes.error
                        : classes.success)
                  )}
                />
                {userNameAvialibilityInfo}
                <Input
                  name="password"
                  value={password}
                  setValue={setPassword}
                  type="password"
                  placeholder="Password"
                  className={clsx(
                    errors.passwordMismatch && formSubmitted && classes.error
                  )}
                />
                <Input
                  name="confirmPassword"
                  value={confirmPassword}
                  setValue={setConfirmPassword}
                  type="password"
                  placeholder="Confirm Password"
                  className={clsx(
                    errors.passwordMismatch && formSubmitted && classes.error
                  )}
                />
                {passwordMismatchInfo}
              </div>{" "}
              <Button type="submit" wFull>
                Submit
              </Button>
              <div className={classes.alreadyHave}>
                <Text sm primitive200>
                  Already have an account?
                </Text>
                <Button
                  transparent
                  to="/login"
                  sm
                  className={classes.logiButton}
                >
                  Login <FaArrowRightLong className={classes.icon} />
                </Button>
              </div>
            </form>

            <DeployService />
          </div>
        )}
        {accountCreated && (
          <AccountCreated
            heading="Account Created!"
            info="Thank you for signing up! We’ve sent a verification link to your email. Please check your email and verify to activate your account."
            buttonText="Go to Dashboard"
            to="/dashboard"
          />
        )}
      </main>
    </>
  );
};

export default SignUp;
